<template>
  <layout-content :title="title">
    <template slot="header">
      {{ $t(`${$route.meta.title['code']}`, { name: title }) }}
    </template>

    <template slot="top-buttons">
      <i-button size="large" icon="md-arrow-down" @click="make_import">
        {{ $t('db.recipient.button.import') }}
      </i-button>
      <i-button size="large" type="primary" @click="create_task">
        {{ $t('autocaller_v2.task.button.create') }}
      </i-button>
    </template>

    <filter-component />
    <table-component :use_skills_in_campaign="use_skills" />
  </layout-content>
</template>
<script>
  import TableComponent from '@autocaller_v2/components/task-table.vue';
  import FilterComponent from '@autocaller_v2/components/task-table-filter.vue';
  import { TaskModalService } from '@autocaller_v2/modals/TaskModalService';
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';

  import { mapActions } from 'vuex';
  export default {
    components: {
      TableComponent,
      FilterComponent
    },
    data() {
      return {
        title: ''
      };
    },
    created() {
      this.getCampaign();
    },
    methods: {
      ...mapActions('autocaller_v2/campaigns/tasks/table', ['getAsyncData']),
      getCampaign() {
        CampaignsService.getItem(this.$route.params.id).then((response) => {
          this.title = response.name;
          this.use_skills = response.skills;
        });
      },
      make_import: function () {
        TaskModalService.import(this.$route.params.id).on('success', () => this.getAsyncData());
      },
      create_task: function () {
        TaskModalService.create(this.$route.params.id, this.use_skills).on('success', () => this.getAsyncData());
      }
    }
  };
</script>